import { FC, ReactNode } from 'react';
import { Box, Typography } from '@altermaind/web/ui';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { InitialsAvatar } from '../InitialsAvatar';

type Props = {
  fullName: string;
  children?: ReactNode;
};

export const HeaderProfile: FC<Props> = ({ fullName, children }) => {
  const { genericResponsiveValue } = useResponsiveStyle();
  const { isDesktop } = useBreakingPoints();

  const letters = fullName
    .split(' ')
    .filter(Boolean)
    .map(n => n[0])
    .join(' ')
    .toUpperCase();

  return (
    <Box
      display='flex'
      flexDirection={genericResponsiveValue({
        breakPoints: { desktop: 'row' },
        defaultValue: 'column',
      })}
      height={genericResponsiveValue({
        breakPoints: { desktop: '80px' },
        defaultValue: 'auto',
      })}
    >
      {isDesktop ? (
        <Box
          top='-120px'
          backgroundColor='primary'
          display='flex'
          flexDirection='column'
          borderRadius='m'
          height={genericResponsiveValue({
            breakPoints: { desktop: '160px' },
            defaultValue: 'auto',
          })}
          position='relative'
          flex={0}
        >
          <InitialsAvatar text={letters} size={160} textProps={{ fontSize: 70 as never }} />
        </Box>
      ) : null}
      <Typography
        ml={genericResponsiveValue({
          breakPoints: { desktop: 'm' },
          defaultValue: 'xxxs',
        })}
        mt={genericResponsiveValue({
          breakPoints: { desktop: 'none' },
          defaultValue: 'none',
        })}
        mb={genericResponsiveValue({
          breakPoints: { desktop: 'none' },
          defaultValue: 's',
        })}
        variant={genericResponsiveValue({
          breakPoints: { desktop: 'h2' },
          defaultValue: 'h1',
        })}
      >
        {fullName}
      </Typography>
      {children}
    </Box>
  );
};
